import React from 'react';
import { Button, Card } from 'antd';
import ServiceableUrlsTable from '../serviceableUrls/table/ServiceableUrlsTable';
import { useDeleteServiceableUrlMutation } from '../serviceableUrls/service';
import LoaderCard from '../shared/LoaderCard';
import useFetchAffectedUrlsPage from './hooks/useFetchAffectedUrlsPage';
import useAddUrlAnalysisProcessWithNotification from '../process/hooks/useAddUrlAnalysisProcessWithNotification';
import { useFetchUrlClustersQuery } from '../urlClusters/service';

type Props = {
    websiteGuid: string;
    seoTestKey: string;
};

export default function AffectedUrls({ websiteGuid, seoTestKey }: Props) {
    const { affectedUrls, isFetchingAffectedUrlsNextPage, isLoadingAffectedUrlsFirstPage, hasMore, handleLoadMore } = useFetchAffectedUrlsPage({
        websiteGuid,
        seoTestKey,
    });
    const { data: urlClusters, isLoading: isLoadingUrlClusters } = useFetchUrlClustersQuery({ w_guid: websiteGuid });
    const { addUrlAnalysisProcess, isAddingUrlAnalysisProcess } = useAddUrlAnalysisProcessWithNotification();

    const [deleteServiceableUrl, { isLoading: isDeletingUrl }] = useDeleteServiceableUrlMutation();

    const handleCheckUrlClick = async (urlGuid: string) => {
        addUrlAnalysisProcess(websiteGuid, urlGuid);
    };

    const handleDeleteUrlClick = (urlGuid: string) => {
        deleteServiceableUrl({ w_guid: websiteGuid, url_guid: urlGuid });
    };

    const isLoading = isLoadingAffectedUrlsFirstPage || isLoadingUrlClusters;
    return (
        <>
            {isLoading && <LoaderCard />}
            {!isLoading && (
                <Card>
                    <ServiceableUrlsTable
                        serviceableUrls={affectedUrls}
                        urlClusters={urlClusters || []}
                        isCheckButtonLoading={isAddingUrlAnalysisProcess}
                        isDeleteButtonLoading={isDeletingUrl}
                        onCheck={handleCheckUrlClick}
                        onDelete={handleDeleteUrlClick}
                        seoTestKey={seoTestKey}
                        showClusterLabel
                    />
                    {hasMore && (
                        <Button
                            type="primary"
                            size="small"
                            onClick={handleLoadMore}
                            loading={isFetchingAffectedUrlsNextPage}
                        >
                            Load more
                        </Button>
                    )}
                </Card>
            )}
        </>
    );
}
